package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.ClientRepository

class SyncClientsFromAppointmentsUseCase(
    private val repository: ClientRepository
) {
    suspend operator fun invoke(): Result<Unit> {
        return repository.syncClientsFromAppointments()
    }
}
